import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getOneSystemNew } from '../../../api/system';

const useCurrentSystem = (
  systemId: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['getOneSystemNew', systemId],
    queryFn: () => getOneSystemNew(systemId),
    ...options,
  });
};

export default useCurrentSystem;
